enum EntityType {
  OPEX = "Opex",
  TEAM = "Team",
  EMPLOYEE = "Employee",
  COST_CENTER = "CostCenter",
}

export default EntityType;
